import React from "react";
import {
  AppBar,
  Toolbar,
  Avatar,
  Box,
  ThemeProvider,
  createTheme,
  Tabs,
  Tab,
} from "@mui/material";
import { useAuth } from "../utils/userAuth";
import { Navigate, Link, useLocation } from "react-router-dom";
import { getUrlWithoutHost } from "../utils/url";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

interface DobbyGenericPageProps {
  children: React.ReactNode;
  fullHeight?: boolean;
  style?: React.CSSProperties;
  sx?: object;
  title?: string;
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#000", // Customize app bar color
    },
    success: {
      main: "#b2dfdb", // pastel teal
      contrastText: "#004d40",
    },
    error: {
      main: "#ffcdd2", // pastel red
      contrastText: "#b71c1c",
    },
    // MUI doesn't have a 'default' slot for color props,
    // but you can define a custom one if needed
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

const DobbyDemoPage: React.FC<DobbyGenericPageProps> = ({
  children,
  fullHeight = false,
  style,
  sx,
  title,
}) => {
  const { isLoggedIn, checkAuth } = useAuth();
  const location = useLocation();

  if (!isLoggedIn) {
    const redirectUrl = getUrlWithoutHost();
    return <Navigate to={`/user/login?redirectUrl=${redirectUrl}`} replace />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: fullHeight ? "100vh" : "auto",
          ...sx,
        }}
        style={style}
      >
        <AppBar position="static" color="primary">
          <Toolbar>
            <Avatar
              src="/www/assets/dobby_internal_tools_icon.png"
              alt="Dobby Tools Icon"
              sx={{ marginRight: 2, width: 40, height: 40 }}
            />
            {title && (
              <Box sx={{ color: "white", fontSize: 20, fontWeight: 500 }}>
                {title}
              </Box>
            )}
            <Box sx={{ flexGrow: 1 }} />
            <Tabs
              sx={{
                "& .MuiTabs-indicator": {
                  backgroundColor: "#fedf33",
                  height: "5px",
                },
              }}
              value={location.pathname}
              textColor="inherit"
              aria-label="navigation tabs"
            >
              <Tab
                icon={<LocalShippingIcon />}
                label="Shipment Feed"
                iconPosition="start"
                value="/demo/shipmentFeed"
                component={Link}
                to="/demo/shipmentFeed"
              />
              <Tab
                icon={<NotificationsActiveIcon />}
                label="Reminders"
                iconPosition="start"
                value="/demo/reminders"
                component={Link}
                to="/demo/reminders"
              />
            </Tabs>
          </Toolbar>
        </AppBar>
        <Box
          sx={{
            p: 0,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            height: fullHeight ? "calc(100vh - 64px)" : "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default DobbyDemoPage;
